import React from 'react'

const IconCheck = props => (
  <svg
    className="icon"
    width={32}
    height={33}
    viewBox="0 0 32 33"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M12 20.348a8.28 8.28 0 1 0 0-16.56 8.28 8.28 0 0 0 0 16.56Z"
      fill="#DF0024"
      className="shieldCheckFillPrimaryBackground"
    />
    <path
      d="M19.78 12.068a7.78 7.78 0 0 1-7.78 7.78v1a8.78 8.78 0 0 0 8.78-8.78h-1ZM12 19.848a7.78 7.78 0 0 1-7.78-7.78h-1a8.78 8.78 0 0 0 8.78 8.78v-1Zm-7.78-7.78A7.78 7.78 0 0 1 12 4.288v-1a8.78 8.78 0 0 0-8.78 8.78h1ZM12 4.288a7.78 7.78 0 0 1 7.78 7.78h1A8.78 8.78 0 0 0 12 3.288v1Z"
      fill="#DF0024"
      className="shieldCheckFillPrimaryBackground"
    />
    <path
      d="m8.138 12.188 2.497 2.498L15.87 9.45"
      stroke="#fff"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export default IconCheck
